import { DemiBold } from "styles/text";
import { PickemCreateGroupForm } from "components/Group/CreateGroup/PickemCreateGroupForm";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";

export const PickemCreateGroupPage = () => {
  return (
    <SingleColumnPage>
      <Panel type="information" padding="padded">
        <span>
          Create a group to compete and enjoy all that Pick'em has to offer with
          your community. Groups will use your regular picks that are also used
          in the global leaderboard, but is a convenient way to see a ranking
          amongst your community.
        </span>
        <br />
        <ul>
          <DemiBold>Open</DemiBold> - Anyone with the link or code can join
        </ul>
        <ul>
          <DemiBold>Request</DemiBold> - Anyone with the link or code can
          request, but needs approval from you or your designated admins
        </ul>
        <ul>
          <DemiBold>Closed</DemiBold> - Satisfied with the members, can disable
          anyone else's ability to request or join.
        </ul>
      </Panel>
      <Panel header="Create A Pickem Group">
        <PickemCreateGroupForm />
      </Panel>
    </SingleColumnPage>
  );
};
